import { resolve } from '../../mixins/dependency';
import { MobileDeviceService } from '../../services/mobile-device';
import { CSSResultGroup, LitElement, TemplateResult, html } from 'lit';
import { ConfigService } from '../../services/config-service';
import { AhoyFlavor } from '@ahoy/types';
import { DeviceType } from '@ahoy/types';

export class DeviceAwareComponent extends LitElement {
  protected userDevice: DeviceType;
  protected appFlavor: AhoyFlavor;
  protected appLangDir: 'rtl' | 'ltr' = document.body.dataset.dir as 'ltr' | 'rtl';

  protected static get baseStyles(): CSSResultGroup {
    return [];
  }
  protected static get desktopStyles(): CSSResultGroup {
    return [];
  }
  protected static get mobileStyles(): CSSResultGroup {
    return [];
  }
  protected static get rtlStyles(): CSSResultGroup {
    return [];
  }
  protected static get ltrStyles(): CSSResultGroup {
    return [];
  }

  private _targetStyle: CSSResultGroup;
  private _rtlLangStyle: CSSResultGroup;
  private _ltrLangStyle: CSSResultGroup;

  constructor() {
    super();
    const ctor = this.constructor as typeof DeviceAwareComponent;
    this._targetStyle = ctor.baseStyles;
    this._rtlLangStyle = ctor.rtlStyles;
    this._ltrLangStyle = ctor.ltrStyles;
    this.appFlavor = (resolve(ConfigService.serviceName) as ConfigService).get('flavor') as AhoyFlavor;
    if (MobileDeviceService.mobileDetected) {
      this._targetStyle = [ctor.baseStyles, ctor.mobileStyles];
      this.dataset.device = this.userDevice = 'mobile';
    } else {
      this.dataset.device = this.userDevice = 'desktop';
      this._targetStyle = [ctor.baseStyles, ctor.desktopStyles];
    }

  }

  protected override render() {
    return html`
      <style data-type="common">${this._targetStyle}</style>
      <style data-type="${this.appLangDir}">${this.appLangDir === 'rtl' ? this._rtlLangStyle : this._ltrLangStyle}</style>
      ${this.renderContent()}
    `;
  }

  renderContent(): TemplateResult | unknown {
    return void 0;
  }
}